import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6 0C2.67273 0 0 2.67273 0 6C0 9.32727 2.67273 12 6 12C9.32727 12 12 9.32727 12 6C12 2.67273 9.32727 0 6 0ZM9 7.30909C9 7.41818 8.89091 7.52727 8.78182 7.52727H4.74545H4.69091H4.63636C4.52727 7.47273 4.47273 7.41818 4.47273 7.30909V3.27273C4.47273 3.16364 4.58182 3.05455 4.69091 3.05455H5.72727C5.83636 3.05455 5.94545 3.16364 5.94545 3.27273V6.05455H8.72727C8.83636 6.05455 8.94545 6.16364 8.94545 6.27273V7.30909H9Z"
        fill="#0C9AD6"
      />
    </svg>
  );
}

export default Icon;
